import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "./api.ts";

/**
 * Defaults pensados para POS:
 * - staleTime alto (catálogo cambia poco) — el sync de Fase 2 invalidará claves.
 * - retry inteligente: no reintentar errores 4xx (son lógicos, no transitorios).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 10 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
